var YouboraObject = require('../object')

var BlockDetector = YouboraObject.extend({
  constructor: function () {
    this.isBlocked = null
    this.xhr = null
    try {
      if (XMLHttpRequest) {
        this.xhr = new XMLHttpRequest()
      } else {
        this.xhr = new ActiveXObject('Microsoft.XMLHTTP')
      }
    } catch (err) {
      return null
    }
    var url = 'http://çç.zxcvççds.com/çç/ççds/-imççge-ççd_ççds.html'
    this.xhr.open('GET', url.replace(/çç/g, 'a'), true)
    this.xhr.addEventListener('load', this.notBlocked.bind(this))
    this.xhr.addEventListener('error', this.blocked.bind(this))
    this.xhr.send()
  },

  blocked: function (e) {
    this.isBlocked = true
  },
  notBlocked: function (e) {
    this.isBlocked = false
  }
})

module.exports = BlockDetector
